import { resolveApiUrl } from "~/utils/url/urlResolver";
import { apiGET } from "~/app/api/apiCallsService";
import {
  type AvailabilityInfo,
  type AvailabilityInfoDTO,
  transformAvailability,
} from "~/domains/product/api/pna/AvailabilityInfo";

const apiUrl = resolveApiUrl("/pna/getLcAvailability");

export async function getLinearAvailabilityInfo(
  productCode: string,
  configurationId: string,
  // priceReference: string
): Promise<AvailabilityInfo> {
  // if (priceReference === "" && HAS_END_CUSTOMER) {
  //   priceReference = window.SCHA.config.priceReferences[1].value;
  // }

  const url = `${apiUrl}/${productCode}/${configurationId}`;
  // if (priceReference) {
  //   url += `/?priceReference=${priceReference}`;
  // }

  const response = await apiGET(url);
  if (!response.ok) {
    throw new Error("Error fetching data");
  }
  const dto = (await response.json()) as AvailabilityInfoDTO;
  const res = transformAvailability(dto);
  // res.forEach((x) => (x.priceReference = priceReference));
  return res;
}
